import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import CustomPagination from '../../elements/CustomPagination';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton } from '@albo-ui/core';
import { Box, IconButton, MenuItem, TextField, InputAdornment } from '@mui/material';
import { ManageCommissions } from '../../modals/sales-manager/ManageComissions';
import { Search, SupportAgent, Clear } from '@mui/icons-material';
import { CRMSalesProps } from './types';
import { ItemConfirmDialog } from '../../modals/confirm';
import { useCRMCommission } from './hooks/useCRMCommission';
import { customStylesCrm } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';

export const CRMCommissionsTable = ({ changeAlert, changeLoader, sectionData }: CRMSalesProps) => {    
    const { data, item, formFind, columns, loading: loadingTable, tabActive, pagination, dialogProps, dialogConfirm, dialogText, row, saveData, onHandleSearch, onHandleChangeFind, clearInput, changePage, handleChangeRowsPerPage, expandInfo, onUpdateCommissions, setRow, onHandleDelete } = useCRMCommission(changeAlert);
    const { theme } = useThemeProvider();

    const onCloseDialogConfirm = () => {
        dialogConfirm.onClose();
        setRow(null);
    };
    const onCloseDialogAction = () => {
        dialogProps.onClose();        
    };
    const onConfirmAction = (payload) => {
        dialogProps.onClose();
        onUpdateCommissions(payload, tabActive)
    };

    useEffect(() => {
        saveData(sectionData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
      
    return (
        <>
            <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, marginTop: 3 }}> 
                <FlexGrid container fullWidth justify='space-between'>

                {loadingTable ? 
                    <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                    :
                    <>
                    <FlexGrid item>
                        <Typography variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                            <SupportAgent sx={{ marginRight: 1 }}/> Gestor de Comisiones
                        </Typography>
                        <Box my={1} sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
                            {pagination.totalDocuments} registro(s)
                        </Box>
                    </FlexGrid>
  
                    <Box sx={{width: "60%"}}>
                        <FlexGrid container spacing={2} style={{alignSelf: 'end'}} fullWidth>
                            <TextField select value={formFind["filters"]['search_type'] || -1} onChange={onHandleChangeFind.bind(this, "search_type", null)} defaultValue={-1} size='small' sx={{width: 300}} color='secondary'>
                                <MenuItem value={-1} disabled>Tipo de dato</MenuItem>
                                {tabActive === "lead" && <MenuItem value={'onboarding_email'}>Email</MenuItem>}
                                {tabActive === "lead" && <MenuItem value={'company_name'}>Nombre de empresa</MenuItem>}
                                {tabActive === "lead" && <MenuItem value={'company_phone'}>Teléfono</MenuItem>}
                                {tabActive !== "lead" && <MenuItem value={'email'}>Email</MenuItem>}
                                {tabActive !== "lead" && <MenuItem value={'name'}>Nombre del vendedor</MenuItem>}
                            </TextField>
                            <TextField
                                label={'Ingrese un dato de búsqueda...'} value={formFind["filters"]['keyword'] || ''} color='secondary' size='small' fullWidth 
                                InputProps={{
                                    style: {height: 40},
                                    endAdornment: (
                                        formFind["filters"]['keyword'] && <InputAdornment position="end">
                                            <IconButton onClick={clearInput.bind(this)} edge="end">                
                                                <Clear />
                                            </IconButton> 
                                        </InputAdornment>
                                    ),
                                }} 
                                onChange={onHandleChangeFind.bind(this, 'keyword', null)}
                            />
                            
                            <IconButton onClick={onHandleSearch.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '7px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: '#8bc179' }}/></IconButton>
                            {/* <Button onClick={openMenu} style={{width: 220, height: 40}}>{tabActive === 'lead'? "Crear Deal" : "Crear Lead"}</Button> */}
                        </FlexGrid>
                    </Box>
                    </>
                }

                </FlexGrid>
                {loadingTable ? 
                    <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                    :
                    <>
                        {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
                            <Tabs value={tabActive} indicatorColor='secondary' textColor='secondary' >
                                {tabs.map((item, index) => {
                                    return <Tab key={index} label={item.title} value={item.name} onClick={changeTab.bind(this, item.name, null)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14}} />
                                })}
                            </Tabs>
                        </Box> */}
                        <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                            {
                                loadingTable ?
                                    <Skeleton width='100%' height='100px' />
                                    :
                                    <>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        customStyles={customStylesCrm}
                                        noDataComponent={noDataComponent}
                                        progressPending={loadingTable}
                                        expandOnRowClicked={false}
                                        expandableRows
                                        expandableRowsComponent={expandInfo.bind(this)}
                                    />
                                    <CustomPagination 
                                        rows={pagination.totalDocuments}
                                        page={pagination.page - 1}
                                        rowsPerPage={pagination.rowsPerPage}
                                        handleChangePage={changePage}
                                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                    </>

                            }
                        </FlexGrid>
                    </>

                }
            </Card>

            <ItemConfirmDialog 
                open={dialogConfirm.open}
                title={dialogText["title"]}
                message={dialogText["message"]}
                onClose={onCloseDialogConfirm} 
                onConfirm={onHandleDelete.bind(this)} 
                item={row && row["company_name"]}
            />
            
            <ManageCommissions
                item={item}
                fromTable={true}
                type={tabActive}
                open={dialogProps.open}
                onClose={onCloseDialogAction}
                onConfirm={onConfirmAction}
                changeLoader={changeLoader}
                changeAlert={changeAlert}
            />
            
        </>
    )
};